var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"app-top"},[_c('swiper-list',{attrs:{"dataList":_vm.swiperList,"height":350,"interval":4000}})],1),_c('soft-list',{attrs:{"btnDownload":true,"btnBuy":true}}),_c('comm-faq'),_c('comm-desc')],1)}
var staticRenderFns = []

export { render, staticRenderFns }